import { ENTRY, WIDGET } from '../../constants/entityTypes';
import { UPDATE, DELETE } from '../../constants/actionsTypes';
import ChangeModel from '../../models/ChangeModel';
import changesQueueInstance from '../ChangesQueue';

class EntryChangeManager {
  changesQueue: typeof changesQueueInstance;
  entityType: string;

  constructor(changesQueue) {
    this.changesQueue = changesQueue;
    this.entityType = ENTRY;
  }

  update(beforeUpdate, afterUpdate, widgetId) {
    const dependencies = new Map([[WIDGET, widgetId]]);
    const change = new ChangeModel(
      this.entityType,
      UPDATE,
      beforeUpdate,
      afterUpdate,
      dependencies,
    );

    return this.changesQueue.addChange(change);
  }

  delete(entity, widgetId) {
    const dependencies = new Map([[WIDGET, widgetId]]);
    const change = new ChangeModel(
      this.entityType,
      DELETE,
      entity,
      null,
      dependencies,
    );

    return this.changesQueue.addChange(change);
  }
}

export default new EntryChangeManager(changesQueueInstance);
